import type { CustomStoreDesign, CustomStoreProduct, CustomStoreProductPage } from '@bloom/shared';
import { resolveStorefrontTheme } from '../../../lib/storefrontTheme';
import './custom-store.css';

export function CustomProductPageView({ design, page, product, onCheckout, preview = false }: {
  design: CustomStoreDesign;
  page: CustomStoreProductPage;
  product: CustomStoreProduct;
  onCheckout?: () => void;
  preview?: boolean;
}) {
  return <article className={`custom-store custom-store--${design.template}`} style={resolveStorefrontTheme({ customAccent: design.accent, customFont: design.font }).cssVars as React.CSSProperties}>
    <header className="custom-hero">
      <h1>{page.heading}</h1>
      <p className="custom-intro">{page.introduction}</p>
      <p className="mb-5 text-lg font-semibold">{product.displayName} · ${product.price.toFixed(2)}</p>
      <button className="custom-button" type="button" disabled={preview || !onCheckout} onClick={onCheckout}>Continue to checkout</button>
    </header>
    {page.sections.map((section, index) => <section className="custom-section" key={index}>
      <h2>{section.heading}</h2><p className="max-w-prose whitespace-pre-line leading-relaxed">{section.body}</p>
    </section>)}
    {page.faqs.length > 0 && <section className="custom-section custom-faq"><h2>Questions about this treatment</h2>
      {page.faqs.map((faq, index) => <details key={index}><summary>{faq.question}</summary><p>{faq.answer}</p></details>)}
    </section>}
  </article>;
}
